import React from 'react';

import OnbFinishRegistration from '@/onboarding/registration/OnbFinishRegistration';

function FinishRegistration() {
    return <OnbFinishRegistration />;
}

export default FinishRegistration;
